import Header from './components/Header';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import ContentSection from './components/ContentSection';
import BenefitsSection from './components/BenefitsSection';
import ArticlesPreview from './components/ArticlesPreview';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';
import { SITE_URL } from '@/constants';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Sugargoo Sheet',
  url: SITE_URL,
  description: 'The most complete Sugargoo Spreadsheet and shopping intelligence platform — discover updated product finds, QC guides, reviews, shipping cost explanations, coupons, warehouse information, and expert buying tips.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${SITE_URL}/?s={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
  inLanguage: 'en',
};

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <JsonLd schema={websiteSchema} />
      <Header />
      <Hero />
      <CategorySection />
      <ContentSection />
      <BenefitsSection />
      <ArticlesPreview />
      <Footer />
    </main>
  );
}